/*
 *
 * DashboardContainer constants
 *
 */
import {
  SUMMARY,
  TRANSACTIONS,
  SETTLEMENTS,
  EASY_SPLIT,
  PAYMENT_LINKS,
  PAYMENT_FORMS,
  PRODUCT_LINKS,
  SUBSCRIPTIONS,
  SOFTPOS,
  REPORTS,
  DEVELOPERS,
  SETTINGS,
  ROUTER,
  GATEWAY_PLUS,
  OFFERS,
  APPS,
  ROUTER_ANALYTICS,
  QR_CODE,
  PAYMENT_BUTTONS,
  STATUS_PAGE,
  RISKSHIELD,
  CUSTOMERS,
  VBA_CONFIGURATION,
  ECOM_360,
  ECOM_360_V2,
  ECOM_360_ACTIVATED,
  CHECKOUT_ONE,
  EMBEDDABLE_COMPONENTS,
  PAYMENT_VERIFICATION,
} from '../../utils/constants';

export const BASE_ACTION_CONSTANT = 'app/DashboardContainer';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const UPDATE_MENU_SELECTED = `${BASE_ACTION_CONSTANT}/UPDATE_MENU_SELECTED`;

export const FETCH_MERCHANT_DETAILS = `${BASE_ACTION_CONSTANT}/FETCH_MERCHANT_DETAILS`;

export const SAVE_MERCHANT_DETAIL_RESPONSE = `${BASE_ACTION_CONSTANT}/SAVE_MERCHANT_DETAIL_RESPONSE`;

export const GET_SUBSCRIPTION_STATUS = `${BASE_ACTION_CONSTANT}/GET_SUBSCRIPTION_STATUS`;

export const UPDATE_SUBSCRIPTION_STATUS = `${BASE_ACTION_CONSTANT}/UPDATE_SUBSCRIPTION_STATUS`;

export const SAVE_CAPTURE_CONFIG = `${BASE_ACTION_CONSTANT}/SAVE_CAPTURE_CONFIG`;

export const FETCH_MERCHANT_TRANSACTION_STATUS = `${BASE_ACTION_CONSTANT}/FETCH_MERCHANT_TRANSACTION_STATUS`;

export const FETCH_REFLECT_SHAREABLE_LINK = `${BASE_ACTION_CONSTANT}/FETCH_REFLECT_SHAREABLE_LINK`;

export const PG_DASHBOARD_MENU = [
  {
    displayText: 'Summary',
    name: SUMMARY,
  },
  {
    displayText: 'Transactions',
    name: TRANSACTIONS,
  },
  {
    displayText: 'Settlements',
    name: SETTLEMENTS,
  },
  {
    displayText: 'Payment Verification',
    name: PAYMENT_VERIFICATION,
  },
  {
    displayText: 'Easy Split',
    name: EASY_SPLIT,
  },
  {
    displayText: 'Payment Links',
    name: PAYMENT_LINKS,
  },
  {
    displayText: 'Payment Forms',
    name: PAYMENT_FORMS,
  },
  {
    displayText: 'Payment Buttons',
    name: PAYMENT_BUTTONS,
  },
  {
    displayText: 'Customers',
    name: CUSTOMERS,
  },
  {
    displayText: 'Offers',
    name: OFFERS,
  },
  {
    displayText: 'Product Links',
    name: PRODUCT_LINKS,
  },
  {
    displayText: 'Subscriptions',
    name: SUBSCRIPTIONS,
  },
  {
    displayText: 'softPOS',
    name: SOFTPOS,
  },
  {
    displayText: 'Reports',
    name: REPORTS,
    label: 'New',
  },
  {
    displayText: 'flowWise',
    name: ROUTER,
    label: 'New',
  },
  {
    displayText: 'Gateway+',
    name: GATEWAY_PLUS,
  },
  {
    displayText: 'Checkout One',
    name: CHECKOUT_ONE,
  },
  {
    displayText: 'Apps',
    name: APPS,
    label: 'New',
  },
  {
    displayText: 'Analytics',
    name: ROUTER_ANALYTICS,
    label: 'New',
  },
  {
    displayText: 'QR Code',
    name: QR_CODE,
    label: 'New',
  },
  {
    displayText: 'Riskshield',
    name: RISKSHIELD,
    label: 'Exclusive Access',
  },
  {
    displayText: 'VBA Configuration',
    name: VBA_CONFIGURATION,
  },
  {
    displayText: 'One Click Checkout',
    name: ECOM_360,
  },
  {
    displayText: 'One Click Checkout',
    name: ECOM_360_V2,
  },
  {
    displayText: 'One Click Checkout',
    name: ECOM_360_ACTIVATED,
  },
  {
    displayText: 'Embeddable Component',
    name: EMBEDDABLE_COMPONENTS,
  },
  {
    displayText: 'Workflows',
    name: 'WORKFLOWS',
    label: 'New',
  },
];

export const GLOBAL_PG_MENU = [
  {
    name: SETTINGS,
    key: 'SETTINGS',
    isActive: true,
    header: 'Settings',
    subheaders: [],
    displayText: 'Settings',
  },
  {
    name: DEVELOPERS,
    key: 'DEVELOPERS',
    isActive: true,
    header: 'Developers',
    subheaders: [],
    displayText: 'Developers',
  },
  {
    name: STATUS_PAGE,
    key: 'STATUS_PAGE',
    isActive: true,
    header: 'Status-page',
    subheaders: [],
    displayText: 'Status Page',
  },
];

export const FETCH_PG_DASHBOARD_STATUS_DATA = `${BASE_ACTION_CONSTANT}/FETCH_PG_DASHBOARD_STATUS_DATA`;

export const UPDATE_LOADER_FOR_DASHBOARD = `${BASE_ACTION_CONSTANT}/UPDATE_LOADER_FOR_DASHBOARD`;

export const UPDATE_PG_DASHBOARD_STATUS_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_PG_DASHBOARD_STATUS_DATA`;

export const UPDATE_STATUS = `${BASE_ACTION_CONSTANT}/UPDATE_STATUS`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const UPDATE_PG_DASHBOARD_CONFIG = `${BASE_ACTION_CONSTANT}/UPDATE_PG_DASHBOARD_CONFIG`;

export const FETCH_PG_CAPTURE_CONFIG = `${BASE_ACTION_CONSTANT}/FETCH_PG_CAPTURE_CONFIG`;

export const GET_MERCHANT_CHECKLIST_PREFERENCE = `${BASE_ACTION_CONSTANT}/GET_MERCHANT_CHECKLIST_PREFERENCE`;

export const INTERNAL_MERCHANT_IDS = [
  '603',
  '1848',
  '86360',
  '61073',
  '63682',
  '119232',
  '93996',
  '86362',
];

export const SHOW_SWITCH_BUTTON_FOR_MERCHANTS = []; // might have to be added again

export const TIMELINE_PATH = 'view';

export const PAYMENT_LINK_DESCRIPTION_PATH = 'payment-link-description';

export const PAYMENT_FORM_DESCRIPTION_PATH = 'payment-form-description';

export const PAYMENT_BUTTON_DESCRIPTION_PATH = 'payment-button-description';

export const PRODUCT_LINK_DESCRIPTION_PATH = 'product-description';

export const ORDERS_DESCRIPTION_PATH = 'orders-description';

export const OFFERS_DESCRITION_PATH = 'offers-description';

export const OFFERS_DESCRITION_PATH_V2 = 'offersV2-description-v2';

export const SETTLEMENT_DETAILS_PATH = 'settlement-details';

export const BLACK_LIST_DETAILS_PATH = 'blacklist-details';

export const BLACK_LIST_DETAILS = 'BLACK_LIST_DETAILS';

export const RECOVERY_CAMPAIGN_CONFIGURATION =
  'RECOVERY_CAMPAIGN_CONFIGURATION';

export const SETTLEMENT_DETAILS = 'SETTLEMENT_DETAILS';

export const SETTLEMENT_RECON_DETAILS = 'SETTLEMENT_RECON_DETAILS';

export const TIMELINE = 'TIMELINE';

export const SUBSCRIPTION_DETAILS = 'SUBSCRIPTION_DETAILS';

export const OFFERS_DESCRIPTION = 'OFFERS_DESCRIPTION';

export const OFFERS_DESCRIPTION_V2 = 'OFFERS_DESCRIPTION_V2';

export const ACTIVE = 'ACTIVE';

export const CHECKLIST_COMPLETE = 'CHECKLIST_COMPLETE';

export const REFUNDS_DETAIL = 'REFUNDS_DETAIL';

export const BATCH_REFUNDS = 'BATCH_REFUNDS';
export const BATCH_REFUNDS_PATH = 'v2/batch-refunds';

export const COHORT_LIST_DATA = `${BASE_ACTION_CONSTANT}/COHORT_LIST_DATA`;
export const COHORT_LIST_DATA_SUCCESS = `${BASE_ACTION_CONSTANT}/COHORT_LIST_DATA_SUCCESS`;

export const CONTENT_DATA = {
  [EASY_SPLIT]: {
    description:
      'Collect & Split settlements for all incoming funds with multiple parties using Easy Split. Collect payments from your customers, and set up a flexible settlement cycle to disburse payouts to your vendors.',
    videoData: [
      {
        title: 'ES (Intro)',
        details:
          'Learn in detail about Easy Split and how to split payments to vendors, partners & your own bank accounts.',
        link: 'https://www.youtube.com/embed/_Vde5QDJwg8?start=0&end=53',
        learnMore: 'https://www.cashfree.com/docs/payments/split/overview',
        apiDoc: 'https://docs.cashfree.com/reference/easy-split-overview',
        code: false,
      },
      {
        title: 'Setting API Collection',
        details: 'Learn how to setup the API collection.',
        link: 'https://www.youtube.com/embed/_Vde5QDJwg8?start=95&end=128',
        learnMore: 'https://docs.cashfree.com/reference/easy-split-overview',
        apiDoc: 'https://docs.cashfree.com/reference/easy-split-overview',
        code: false,
      },
      {
        title: 'Add a new Vendor via Merchant Dashboard',
        details: 'Learn how to add a new vendor using our API.',
        link: 'https://www.youtube.com/embed/_Vde5QDJwg8?start=129&end=197',
        learnMore: 'https://www.cashfree.com/docs/payments/split/vendor/add',
        apiDoc: 'https://docs.cashfree.com/reference/create-vendor-v20',
        code: false,
      },
      {
        title: 'Add a new Vendor via API',
        details: 'Learn how to add a new vendor from the merchant dashboard.',
        link: 'https://www.youtube.com/embed/_Vde5QDJwg8?start=198&end=235',
        learnMore: 'https://docs.cashfree.com/reference/create-vendor-v20',
        apiDoc: 'https://docs.cashfree.com/reference/create-vendor-v20',
        code: true,
      },
      {
        title: 'Initiate an Order',
        details: 'Learn how to create an order.',
        link: 'https://www.youtube.com/embed/_Vde5QDJwg8?start=236&end=270',
        learnMore:
          'https://www.cashfree.com/docs/payments/split/recipes/split-a-payment#create-order',
        apiDoc: 'https://docs.cashfree.com/reference/createorder',
        code: false,
      },
      {
        title: 'Make a Payment',
        details: 'Learn how to make a payment once you have created an order.',
        link: 'https://www.youtube.com/embed/_Vde5QDJwg8?start=271&end=304',
        learnMore:
          'https://www.cashfree.com/docs/payments/split/recipes/split-a-payment#create-order',
        apiDoc: 'https://docs.cashfree.com/reference/orderpay',
        code: false,
      },
      {
        title: 'Initiate a Payment Split',
        details: 'Learn how to initiate a payment split',
        link: 'https://www.youtube.com/embed/_Vde5QDJwg8?start=305&end=369',
        learnMore:
          'https://www.cashfree.com/docs/payments/split/recipes/split-a-payment#split-payment',
        apiDoc: 'https://docs.cashfree.com/reference/split-order-apis',
        code: true,
      },
      {
        title: 'Initiate a Refund',
        details: 'Learn how to initiate a refund.',
        link: 'https://www.youtube.com/embed/_Vde5QDJwg8?start=370&end=414',
        learnMore:
          'https://www.cashfree.com/docs/payments/split/refund/initiate#initiate-refunds',
        apiDoc: 'https://docs.cashfree.com/reference/create-refund',
        code: false,
      },
      {
        title: 'Defer a settlement',
        details: 'Learn how to defer settlements in Easy Split.',
        link: 'https://www.youtube.com/embed/_Vde5QDJwg8?start=415&end=473',
        learnMore:
          'https://www.cashfree.com/docs/payments/split/settlements/delay/overview#delay-settlements',
        apiDoc: 'https://docs.cashfree.com/reference/deferred-settlement-1',
        code: true,
      },
      {
        title: 'Reports',
        details: 'Know the various types of reports available in Easy Split.',
        link: 'https://www.youtube.com/embed/_Vde5QDJwg8?start=474&end=510',
        learnMore:
          'https://www.cashfree.com/docs/payments/split/reports/es-reports',
        apiDoc:
          'https://www.cashfree.com/docs/payments/split/reports/es-reports',
        code: false,
      },
      {
        title: 'Vendor Dashboard',
        details:
          'Share access of vendor exclusive dashboard for vendor level reconciliation and reports',
        link: 'https://www.youtube.com/embed/3SxexLTFeiw',
        learnMore:
          'https://www.cashfree.com/docs/payments/split/vendor/dashboard/overview#vendor-dashboard',
        apiDoc:
          'https://www.cashfree.com/docs/payments/split/vendor/dashboard/overview#vendor-dashboard',
        code: false,
      },
    ],
  },
};

export const EASY_SPLIT_DETAILS = 'EASY_SPLIT_DETAILS';

export const EASY_SPLIT_DETAILS_PATH = 'easy-split-details';

export const DISPUTE_DETAILS = 'DISPUTE_DETAILS';

export const DISPUTE_DETAILS_PATH = 'dispute-details';

export const SUBSCRIPTION_DETAILS_PATH = 'subscription-details';

export const SUBSCRIPTION_PAYMENT_DETAILS_PATH = 'subscription-payment-details';

export const PAYMENT_VERIFICATION_DETAILS_PATH = 'payment-verification-details';

export const OFFERS_V2_PATH = 'offers-create';

export const WORKFLOWS = 'WORKFLOWS';

export const WORKFLOWS_FLOWS_PATH = 'workflows/flows';

export const WORKFLOWS_RUNS_PATH = 'workflows/runs';

export const WORKFLOWS_CONNECTIONS_PATH = 'workflows/connections';

export const MERCHANT_TRANSACTION_STATUS = {
  TRANSACTION_DONE: 'TRANSACTION_DONE',
  TRANSACTION_NOT_DONE: 'TRANSACTION_NOT_DONE',
};
export const COLLECTION_POINT_DETAILS = 'COLLECTION_POINT_DETAILS';

export const COLLECTION_POINT_DETAILS_PATH = 'collection-point-details';

export const ANALYTICS_V2 = 'ANALYTICS_V2';

export const SR_PLAYGROUND_PATH = 'playground';

export const SR_PLAYGROUND = 'SR_PLAYGROUND';

export const PAYMENT_VERIFICATION_DETAILS = 'PAYMENT_VERIFICATION_DETAILS';

export const OFFERS_V2_CREATE = 'OFFERS_V2_CREATE';

export const FETCH_REFLECT_SHAREABLE_URL = {
  method: 'GET',
  url: '/pg/reflect-links',
};

export const FETCH_REFLECT_ELIGIBILITY_URL = {
  method: 'GET',
  url: '/reflect/eligibility/$token$?year=2025',
};

export const REFLECT_BASE_URL = 'https://www.cashfree.com/reflect';

export const pathsToCheck = [
  OFFERS_V2_PATH,
  'offersV2',
  OFFERS_DESCRITION_PATH_V2,
];

export const PAGE_SUBTITLE_MAPPING = {
  'aov-booster':
    'Boost your average order value by offering add-ons and product recommendations at their point of purchase',
};
